import "../style/page/report.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  productorder,
  productorderid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import {
  ProductOrderGet,
  pharmacybill,
  oppharmacybillexcel,
  product_return,
  currentCashbackGetApi,
} from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { Chart } from "react-google-charts";
import Modal from "react-modal";
import { set } from "date-fns";
function PharmacyBill(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [checked, setChecked] = useState(false);
  const [popup, setpopup] = useState(false);
  let roledata = localStorage.getItem("role");
  const locationid = useSelector(state => state.counter.loginuser_location_id);

  const [branches, setbranches] = useState(
    locationid != "all" ? locationid : "91"
  );
  const [code, setcode] = useState("all");
  const [codedata, setcodedata] = useState([
    {
      unitcode: 90,
      storecode: "OPC1",
      storename: "Prashanth Pharmacy - Chetpet",
    },
    {
      unitcode: 90,
      storecode: "OPC2",
      storename: " Prashanth Pharmacy WASHERMENPET",
    },
    {
      unitcode: 91,
      storecode: "OPV3",
      storename: "Prashanth Pharmacy - OB Velachery",
    },
    {
      unitcode: 91,
      storecode: "OPV4",
      storename: "Prashanth pharmacy -Velachery NB",
    },
    {
      unitcode: 91,
      storecode: "OPV5",
      storename: " Prashanth IP pharmacy",
    },
    {
      unitcode: 91,
      storecode: "OPV6",
      storename: "Prashanth Pharmacy TAMBARAM",
    },
    {
      unitcode: 92,
      storecode: "OPK",
      storename: "Prashanth Pharmacy OP - Kolathur",
    },
  ]);

  const [doctorcount, setdoctorcount] = useState(0);
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const productstate = useSelector(state => state.counter.productorder);
  const productid = useSelector(state => state.counter.productorderid);
  const [Totalamount, settotalamount] = useState(0);

  const [currentCashbackAmount, setCurrentCashbackAmount] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");

  const [cashbackReturnamount, setCashbackReturnAmount] = useState(0);
  const [returnData, setReturnData] = useState();
  const [revisedCashbackAmount, setRevisedCashbackAmount] = useState(0);
  const [errorAmount, setErrorAmount] = useState(false);
  const [cashBackAmount, setCashBackAmount] = useState(); // [cashBackAmount, setCashBackAmounts]
  const [id, setid] = useState();
  const [refetch, setRefetch] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
  };
  const [ispaid, setispaid] = useState("ALL");
  const [pieChartDataAppo, setPieChartDataAppo] = useState({
    Confirmed: 0,
    Refund: 0,
    Rejected: 0,
  });

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([it, it]);
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: pharmacybill,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            date_gt: range[0],
            date_lt: range[1],
            branch: branches,
            paid: ispaid,
            code: code,
          },
        })
          .then(res => {
            setdoctorcount(0);
            settotalamount(0);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data.data);
            var piedata = {
              Confirmed: res.data.data.Confirmed,
              Refund: res.data.data.Refund,
              Rejected: res.data.data.Rejected,
            };
            setPieChartDataAppo(piedata);

            const intervalId1 = setInterval(() => {
              if (res.data.data_count != 0) {
                setdoctorcount(prevCount => {
                  if (prevCount < res.data.data_count) {
                    return prevCount + 1;
                  } else {
                    clearInterval(intervalId1);
                    return prevCount;
                  }
                });
              }
            });
            settotalamount(res.data.data.amount_paid);
          })
          .catch(error => {});
      }
    } else {
      axios({
        method: "get",
        url: pharmacybill,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          date_gt: range[0],
          date_lt: range[1],
          branch: branches,
          paid: ispaid,
          code: code,
        },
      })
        .then(res => {
          // setRefetch(false);
          setdoctorcount(0);
          settotalamount(0);

          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data.data);
          var piedata = {
            Confirmed: res.data.data.Confirmed,
            Refund: res.data.data.Refund,
            Rejected: res.data.data.Rejected,
          };
          setPieChartDataAppo(piedata);

          const intervalId1 = setInterval(() => {
            if (res.data.data_count != 0) {
              setdoctorcount(prevCount => {
                if (prevCount < res.data.data_count) {
                  return prevCount + 1;
                } else {
                  clearInterval(intervalId1);
                  return prevCount;
                }
              });
            }
          });
          settotalamount(res.data.data.amount_paid);
        })
        .catch(error => {
          // console.log(error);
        });
    }
  }, [
    dtpageindex,
    dtpagesize,
    searchQuery,
    productstate,
    popup,
    range,
    branches,
    ispaid,
    code,
    refetch,
  ]);

  const deleteappoinment = (e, ele) => {
    setReturnData(ele);
    setid(e);
    setCashbackReturnAmount(0);
    console.log(ele, ele.id, ele.return_amount, ele.patient.id, "delete flow");

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-info",
      },
      buttonsStyling: false,
    });

    // Step 1: Confirm action
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "Do You Want To Add Return Amount?",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "Return",
        // cancelButtonText: "Partially used",
        reverseButtons: true,
      })
      .then(async result => {
        if (result.isConfirmed) {
          setCashbackReturnAmount(0);
          setCurrentCashbackAmount(0);
          setCashBackAmount(0);
          setErrorAmount(false);
          setRemarks("");
          setModalOpen(true);
          try {
            // ✅ Step 2: Call GET API after confirmation
            const getRes = await axios({
              method: "get",
              url: currentCashbackGetApi,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
              params: {
                phonenumber: ele?.patient?.phonenumber,
              },
            });

            console.log("✅ Cashback GET API Response:", getRes.data);

            if (getRes.data?.data) {
              setCurrentCashbackAmount(getRes.data?.data.cashback);
              console.log(getRes.data?.data, "Sadasdasdasdasd");
              // window.open(getRes.data.data, "_self");
            }

            // ✅ Step 3: Now show the popup for amount + remarks

            //           swalWithBootstrapButtons
            //             .fire({
            //               title: "Enter Amount and Remarks",
            //               html: `
            //   <div style="margin-bottom: 10px; font-weight: 600;">
            //     Cashback Amount: <span style="color: green;">₹${(
            //       getRes.data?.data.cashback - (cashbackReturnamount || 0) * 0.05 || 0
            //     ).toFixed(2)}</span>
            //   </div>
            //   <div style="margin-bottom: 10px; font-weight: 600;">
            //     Cashback Reduce Amount: <span id="cashback-reduce" style="color: green;">₹${(
            //       (cashbackReturnamount || 0) * 0.05
            //     ).toFixed(2)}</span>
            //   </div>
            //   <input id="swal-input1" class="swal2-input" placeholder="Amount" type="number" value="${cashbackReturnamount}">
            //   <textarea id="swal-input2" class="swal2-textarea" placeholder="Remarks" rows="3"></textarea>
            // `,
            //               confirmButtonText: "Submit",
            //               showCancelButton: true,
            //               showLoaderOnConfirm: true,
            //               didOpen: () => {
            //                 const inputEl = document.getElementById("swal-input1");
            //                 const reduceEl = document.getElementById("cashback-reduce");
            //                 const totalCashback = parseFloat(
            //                   getRes.data?.data.cashback || 0
            //                 );

            //                 // Live update
            //                 inputEl.addEventListener("input", e => {
            //                   let val = parseFloat(e.target.value) || 0;

            //                   // Prevent exceeding total cashback
            //                   if (val > totalCashback) {
            //                     val = totalCashback;
            //                     e.target.value = val;
            //                   }

            //                   // Update React state
            //                   setCashbackReturnAmount(val);

            //                   // Update displayed number — convert to string with 2 decimals
            //                   reduceEl.textContent = `₹${val.toFixed(2)}`;
            //                 });
            //               },
            //               preConfirm: () => {
            //                 const amount = parseFloat(
            //                   document.getElementById("swal-input1").value
            //                 );
            //                 const remarks = document.getElementById("swal-input2").value;

            //                 if (!amount) {
            //                   Swal.showValidationMessage("Amount Cannot Be Empty!");
            //                   return false;
            //                 } else if (amount > ele.base_amount) {
            //                   Swal.showValidationMessage(
            //                     "Amount Cannot Exceed Initial Amount!"
            //                   );
            //                   return false;
            //                 }

            //                 return { amount, remarks };
            //               },
            //             })
            // .then(async inputResult => {
            //   if (inputResult.isConfirmed) {
            //     // ✅ Step 4: POST API after amount confirmation
            //     const data1 = {
            //       type: "pharmacyopbillpayment",
            //       r_totalamount: Number(inputResult.value.amount),
            //       order_id: ele.id,
            //       patient_id: ele?.patient?.id,
            //       remarks: inputResult.value.remarks,
            //     };

            //     console.log("POST Payload:", data1);

            //     const postRes = await axios({
            //       url: product_return,
            //       method: "post",
            //       data: data1,
            //       headers: {
            //         Authorization: "Bearer " + localStorage.getItem("token"),
            //       },
            //     });

            //     console.log(
            //       "✅ Return Amount POST API Response:",
            //       postRes.data
            //     );

            //     setpopup(true);
            //     Swal.fire({
            //       text: "Amount Added Successfully!",
            //       icon: "success",
            //     }).then(() => setpopup(false));
            //   }
            // });
          } catch (err) {
            console.error("❌ Error in GET or POST API:", err);
            Swal.fire(
              "Error",
              "Something went wrong while processing.",
              "error"
            );
          }
        }
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.slno}
              >
                {row.row.original.slno}
              </p>
            </>
          );
        },
      },
      {
        Header: "Created Date",
        accessor: "",

        Cell: row => {
          const dateString = row.row.original.created_date;
          const dateObject = new Date(dateString);

          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

          const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${formattedTime}`}
              >
                {`${
                  row.row.original.created_date.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill Id",
        accessor: "",

        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.isPaid == true
                    ? row.row.original.bill_id
                    : row.row.original.fully_used == true
                    ? row.row.original.bill_id
                    : "--"
                }
              >
                {row.row.original.isPaid == true
                  ? row.row.original.bill_id
                  : row.row.original.fully_used == true
                  ? row.row.original.bill_id
                  : "--"}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={e => {
                  let isCopy = copy(
                    row.row.original.isPaid == true
                      ? row.row.original.bill_id
                      : row.row.original.fully_used == true
                      ? row.row.original.bill_id
                      : "--"
                  );
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Wallet Id",
        accessor: "",

        Cell: row => {
          var pharma_wallet = "--";
          if (
            row.row.original.isPaid == true ||
            row.row.original.fully_used == true
          ) {
            if (row.row.original.wallet_id != null) {
              pharma_wallet = row.row.original.wallet_id;
            } else {
              pharma_wallet = "--";
            }
          }
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={pharma_wallet}
              >
                {pharma_wallet}
              </p>
              {/* <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(pharma_wallet));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button> */}
            </>
          );
        },
      },
      {
        Header: "Payer Name",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Payer UHID",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {row.row.original.patient.p_uhid}
              </p>
            </>
          );
        },
      },
      {
        Header: "Patient details",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                <b>NAME :</b>{" "}
                {row.row.original.paid_to_name == null
                  ? "--"
                  : row.row.original.paid_to_name}
                <br />
                <b>UHID :</b>{" "}
                {row.row.original.uhid == null ? "--" : row.row.original.uhid}
                <br />
                <b>ENCOUNTER :</b>{" "}
                {row.row.original.encounter_id == null
                  ? "--"
                  : row.row.original.encounter_id}
              </p>
            </>
          );
        },
      },
      {
        Header: "Bill Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.bill_amount}
              >
                <span id="prefix">₹</span>
                {row.row.original.bill_amount.toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Initial Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.base_amount}
              >
                <span id="prefix">₹</span>
                {row.row.original.base_amount.toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Initial Wallet ",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.previous_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {row.row.original.previous_cashbackpoints.toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Wallet amount Used",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.used_cashbackpoints}
              >
                <span id="prefix">₹</span>
                {row.row.original.used_cashbackpoints.toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.isPaid == false ? "No" : "Yes"
                }
              >
                {row.row.original.isPaid == true ||
                row.row.original.fully_used == true ? (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                ) : (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                )}
              </p>
            </>
          );
        },
      },
      {
        Header: "Razor Pay",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p>
                {row.row.original.payment_order_id == null
                  ? "--"
                  : row.row.original.payment_order_id}
              </p>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: row => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="appoinment"
                  data-tooltip-content={
                    row.row.original.status == "Confirmed" ? (
                      <p style={{ fontWeight: 700 }}>--</p>
                    ) : row.row.original.status == "Refund" ? (
                      <p style={{ color: "red", fontWeight: 700 }}>Canceled</p>
                    ) : (
                      <p style={{ color: "blue", fontWeight: 700 }}>
                        {row.row.original.status}
                      </p>
                    )
                  }
                >
                  {row.row.original.status == "Confirmed" ? (
                    <p style={{ fontWeight: 700 }}>-- </p>
                  ) : row.row.original.status == "Refund" ? (
                    <p style={{ color: "red", fontWeight: 700 }}>Canceled</p>
                  ) : (
                    <p style={{ color: "blue", fontWeight: 700 }}>
                      {row.row.original.status}
                    </p>
                  )}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Code",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p>
                {row.row.original.code != "" && row.row.original.code != null
                  ? row.row.original.code
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Return Amount",
        accessor: "",
        Cell: row => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.return_amount}
              >
                {parseFloat(row.row.original.return_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: row => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  disabled={
                    row.row.original.isPaid === true ||
                    row.row.original.fully_used === true
                      ? row.row.original.return_amount > 0 ||
                        row.row.original.status == "Refund"
                        ? true
                        : false
                      : true
                  }
                  onClick={e => {
                    console.log(
                      row.row?.original.patient.phonenumber,
                      "djkasdsdsdsdjkasdka"
                    );
                    deleteappoinment(row.row.original.id, row.row.original);
                  }}
                >
                  <i class="bi bi-trash3"></i> Return
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };

  const datadownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want To Download The Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(result => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: oppharmacybillexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            date_gt: range[0],
            date_lt: range[1],
            branch: branches,
            paid: ispaid,
            code: code,
          },
        })
          .then(res => {
            window.open(res.data.data, "_self");
            // Swal.fire(
            //   'Deleted!',
            //   'Your file has been deleted.',
            //   'success'
            // )
          })
          .catch(err => {});
      }
    });
  };

  const handleReturnAmountSubmit = async () => {
    try {
      // Validate before sending
      if (
        cashbackReturnamount > returnData?.base_amount ||
        cashbackReturnamount <= 0
      ) {
        Swal.fire(
          "Validation Error",
          "Amount Cannot Be Empty or Not Greater then Bill Amount!",
          "warning"
        );
        return;
      }

      const data1 = {
        type: "pharmacyopbillpayment",
        r_totalamount: Number(cashbackReturnamount),
        order_id: returnData?.id,
        patient_id: returnData?.patient?.id,
        remarks: remarks || "",
        return_type: "Pharmacy Bill",
        r_cashback_amount: Number(
          currentCashbackAmount >= cashBackAmount
            ? cashBackAmount.toFixed(2)
            : currentCashbackAmount.toFixed(2)
        ),

        r_real_amount:
          cashBackAmount <= Number(currentCashbackAmount.toFixed(2))
            ? cashbackReturnamount
            : (
                cashbackReturnamount -
                (cashBackAmount - Number(currentCashbackAmount.toFixed(2)))
              ).toFixed(2),
      };

      const postRes = await axios({
        url: product_return,
        method: "post",
        data: data1,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      console.log("✅ Return Amount POST API Response:", postRes.data);
      setRefetch(true);
      Swal.fire({
        text: "Amount Added Successfully!",
        icon: "success",
      });
    } catch (err) {
      console.error("❌ Error in POST API:", err);

      Swal.fire("Error", "Something went wrong while processing.", "error");
    } finally {
      setModalOpen(false);
    }
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange(oldArray => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];

  const pie_chart_data = [
    ["Appointment", "count"],
    ["Confirmed", pieChartDataAppo.Confirmed],
    ["Refund", pieChartDataAppo.Refund],
    ["Rejected", pieChartDataAppo.Rejected],
  ];
  const options = {
    title: "Pharmacy Bill List status",
    pieHole: 0.5,
    is3D: false,
    slices: {
      //   0: { color: "lite-blue" },
      2: { color: "green" },
    },
  };
  const toIndianCurrency = num => {
    const curr = num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
    return curr;
  };

  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Pharmacy Bill List</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={e => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Pharmacy Bill List</li>
              </ul>
            </div>
            <div class="col-sm-5 col-auto">
              {" "}
              <div className="datepicker_dash">
                <DateRangePicker
                  defaultValue={[new Date(), new Date()]}
                  disabledDate={date => isAfter(date, new Date())}
                  editable={false}
                  appearance="default"
                  placement="bottomEnd"
                  size="lg"
                  ranges={predefinedBottomRanges}
                  placeholder="From - To"
                  style={{ width: 270, padding: 10, float: "right" }}
                  onClean={e => cleaningrange(e)}
                  onChange={e => {
                    if (e != null) {
                      setrange([]);
                      e.forEach(newValue => {
                        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                        var localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate("validtill", localISOTime);
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{doctorcount}</h3>
                    {/* <h3>{acount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Pharmacy Bill List</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${doctorcount / 10}%` }}
                      aria-valuenow={doctorcount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-cash-coin"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{toIndianCurrency(Totalamount)}</h3>
                    {/* <h3>{acount}</h3> */}
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Total Bill Payments</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${Totalamount / 10}%` }}
                      aria-valuenow={Totalamount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {pieChartDataAppo.Confirmed == 0 &&
          pieChartDataAppo.Refund == 0 &&
          pieChartDataAppo.Rejected == 0 ? (
            <></>
          ) : (
            <div className="col-xl-4 col-sm-6 col-12 pie_chart">
              <Chart
                chartType="PieChart"
                data={pie_chart_data}
                options={options}
                width={"400px"}
                height={"200px"}
              />
            </div>
          )}
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={e => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={e => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <>
                      <div align="center" type="button">
                        <a
                          class="dnbtn"
                          onClick={e => {
                            datadownload();
                          }}
                        ></a>
                      </div>
                      <div
                        class="input-group rounded mr-2 "
                        style={{ width: "250px", height: "40px" }}
                      >
                        <select
                          class="form-select"
                          value={code}
                          name="gender"
                          onChange={e => {
                            setcode(e.target.value);
                          }}
                        >
                          <option selected disabled value="">
                            Filter By Location...
                          </option>
                          <option value="all">All</option>
                          {/* <option value={"OPC1"}>Prashanth Pharmacy - Chetpet</option>
                          <option value={"OPC2"}>Prashanth Pharmacy WASHERMENPET</option>
                          <option value={"OPV3"}> Prashanth Pharmacy - OB Velachery </option>
                          <option value={"OPV4"}>Prashanth pharmacy -Velachery NB</option>
                          <option value={"OPV5"}>Prashanth IP pharmacy</option>
                          <option value={"OPV6"}>Prashanth Pharmacy TAMBARAM</option>
                          <option value={"OPK"}>Prashanth Pharmacy OP - Kolathur</option> */}
                          {codedata.map(ele => {
                            if (branches == ele.unitcode) {
                              return (
                                <option value={ele.storecode}>
                                  {ele.storecode}
                                </option>
                              );
                            }
                          })}
                        </select>
                      </div>
                      {/* <div
                        class="input-group rounded mr-2 "
                        style={{ width: "250px", height: "40px" }}
                      >
                        <select
                          class="form-select"
                          value={branches}
                          name="gender"
                          onChange={(e) => {
                            setbranches(e.target.value);
                          }}
                        >
                          <option selected disabled value="">
                            Filter By Location...
                          </option>
                          <option value={"90"}>CHETPET</option>
                          <option value={"91"}>VELACHERY</option>
                          <option value={"92"}>KOLATHUR</option>
                        </select>

                      </div> */}
                      <div
                        class="rounded mr-2 "
                        style={{
                          width: "250px",
                          height: "40px",
                          borderRadius: "0.375rem !important",
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <p className="w-100 m-0 p-0 text-end">Paid Status</p>

                        <select
                          class="form-select"
                          value={ispaid}
                          name="paid"
                          onChange={e => {
                            setispaid(e.target.value);
                          }}
                        >
                          <option selected disabled value="">
                            Filter By Paid...
                          </option>
                          <option value={"ALL"}>All</option>
                          <option value={"True"}>Yes</option>
                          <option value={"False"}>No</option>
                        </select>
                      </div>
                    </>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />

        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          style={{
            overlay: {
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1000,
            },
            content: {
              maxWidth: "550px",
              margin: "auto",
              padding: "20px",
              height: "auto",
              maxHeight: "490px",
              borderRadius: "10px",
              border: "1px solid #ccc",
              boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
            },
          }}
        >
          <h4 className="text_center_returnAmount">Enter Amount and Remarks</h4>
          <p>
            Cashback Amount:{" "}
            <strong>₹{currentCashbackAmount.toFixed(2)}</strong>
          </p>
          <p>
            Cashback Reduce Amount:{" "}
            <strong>
              ₹
              {currentCashbackAmount >= cashBackAmount
                ? cashBackAmount.toFixed(2)
                : currentCashbackAmount.toFixed(2)}
            </strong>
          </p>
          <p>
            Cash Return Amount:{" "}
            <strong>
              ₹
              {cashBackAmount <= Number(currentCashbackAmount.toFixed(2))
                ? cashbackReturnamount
                : (
                    cashbackReturnamount -
                    (cashBackAmount - Number(currentCashbackAmount.toFixed(2)))
                  ).toFixed(2)}
            </strong>
          </p>
          {/* {revisedCashbackAmount > 0 && ( */}
          {/* <p>
            Revised Cashback Amount:{" "}
            <strong>₹{revisedCashbackAmount.toFixed(2)}</strong>
          </p> */}
          {/* )} */}
          <div
            className="form-group"
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <input
              type="number"
              // value={cashbackReturnamount}
              onChange={e => {
                console.log(returnData, "dakldakjdjklakjld");
                let val = parseFloat(e.target.value) || 0;
                if (val > returnData.base_amount) {
                  setErrorAmount(true);
                } else if (val > returnData.bill_amount) {
                  setRevisedCashbackAmount(val - returnData.bill_amount);
                } else {
                  setRevisedCashbackAmount(0);
                  setErrorAmount(false);
                }
                setCashBackAmount(val * (0.05).toFixed(2));
                // if (val > totalCashback) val = totalCashback; // optional limit
                setCashbackReturnAmount(val);
              }}
              className="input-box"
              placeholder="Return Amount"
            />
            {errorAmount && (
              <span style={{ color: "red" }}>
                Return Amount Cannot Exceed Bill Amount
              </span>
            )}
            <textarea
              className="input-box"
              rows={3}
              placeholder="Remarks"
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
            />
          </div>

          <div
            style={{
              marginTop: 10,
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={handleReturnAmountSubmit}
            >
              {"Submit"}
            </button>
            <button
              className="btn btn-info"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default PharmacyBill;
